/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecapitoVigileDto } from '../../models/recapito-vigile-dto';

export interface ApiRecapitoRecapitoVigileListGet$Params {
    /**
     * Matricola del vigile per cui caricare i contatti
     */
    matricola: string;
}

export function apiRecapitoRecapitoVigileListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiRecapitoRecapitoVigileListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<RecapitoVigileDto>>> {
    const rb = new RequestBuilder(rootUrl, apiRecapitoRecapitoVigileListGet.PATH, 'get');
    if (params) {
        rb.query('matricola', params.matricola, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<RecapitoVigileDto>>;
        }),
    );
}

apiRecapitoRecapitoVigileListGet.PATH = '/api/recapito/recapito-vigile-list';
